import { z } from 'zod';

export const schemaEmail = z.object({
    email: z.string().min(1).email(),
});
export type SchemaEmail = z.infer<typeof schemaEmail>;
